import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack, MdClass, MdEmail, MdEventNote, MdInbox, MdLockReset, MdMailOutline, MdMarkunreadMailbox, MdOutlineSettingsSuggest, MdPeople, MdSchool, MdSettings, MdSettingsAccessibility, MdStorage } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaUserGraduate } from 'react-icons/fa';
import axios from "axios";
import { select } from "slate";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";
import { web_url } from "../../constant";


function ResearcherTranslatorSchoolMatching() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const [openAlert, setOpenAlert] = useState(false);

    const handleClickOpenAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [schoolList, setSchoolList] = useState([])

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t255'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };
    const handleCloseError = () => {
        setOpenError(false);
    };

    const [schoolsSelected, setSchoolsSelected] = useState(["none"])


    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoading(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/schools`

            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        setSchoolList(response.data)
                    } catch {
                        console.log("s not retreived");
                        setSchoolList([]);
                    }


                    if (localStorage.getItem('t-schools')) {
                        if (JSON.parse(localStorage.getItem('t-schools'))) {
                            setSchoolsSelected(JSON.parse(localStorage.getItem('t-schools')));
                        } else {
                            setSchoolsSelected([]);
                        }
                    } else {
                        setSchoolsSelected([]);
                    }

                    setIsLoading(false);
                })
                .catch((err) => {
                    console.log("error occured", err);
                    setIsLoading(false);
                });
        }
    }, [])

    const [isControlSelected, setIsControlSelected] = useState(null);

    const [searchInput, setSearchInput] = useState("");

    const filteredSchools = schoolList.filter((school) =>
        (school.name + " " + school.district).toLowerCase().includes(searchInput.toLowerCase())
    );

    useEffect(() => {
        if (!schoolsSelected.includes("none")) {
            localStorage.setItem('t-schools', JSON.stringify(schoolsSelected));
            console.log('done 1');
        }

    }, [schoolsSelected])

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")}  w-screen xl:pt-[20px]`}>
            {
                isLoading ?
                    <div className="items-center justify-center flex pt-[100px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                    :
                    <div className="pb-[120px]">
                        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]`}>
                            <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                    navigate('/researcher/translator/list')
                                }} />
                                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                    navigate('/researcher/translator/list')
                                }} />
                                <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                                    navigate('/researcher/translator/list')
                                }} />
                                <p className=" font-bold text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px]">{t('t430')}</p>
                            </div>
                        </div>

                        <div className={`mx-[40px] md:mx-[160px] lg:mx-[190px] xl:mx-[300px] ${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")}`}>
                            <input
                                type="search"
                                placeholder={t('t204')}
                                onChange={(e) => setSearchInput(e.target.value)}
                                value={searchInput}
                                className="mt-4 p-2 md:p-3 lg:p-4 xl:p-1 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px]"
                            />
                        </div>

                        <div className="mt-[20px]  px-[20px] md:px-[120px] lg:px-[160px] xl:px-[90px] ">

                            {
                                filteredSchools.length > 0 ?
                                    <>

                                        <div className="max-h-[470px] xl:max-h-[400px]  lg:max-h-[700px] 2xl:max-h-[650px] overflow-y-auto px-4 xl:grid grid-cols-3 xl:gap-[20px]">
                                            {
                                                filteredSchools.map((school, index) => {
                                                    const isSelected = schoolsSelected?.includes(school.id);
                                                    return (
                                                        <div key={index} className={`cursor-pointer ${schoolsSelected?.includes(school.id) ? "border border-[#FAC236] bg-[#FAC236] bg-opacity-20 text-black" : "text-[#8189B0] border border-[#8189B0] bg-[#F1F6FB]"}  w-full py-[10px] flex justify-center items-center rounded-md mb-[10px]`}
                                                            onClick={() => {
                                                                if (!isSelected) {
                                                                    setSchoolsSelected([...schoolsSelected, school.id])

                                                                    if (localStorage.getItem('t-userId')) {
                                                                        setIsLoading(true);
                                                                        const getLogDetails = () => {
                                                                            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                                                                        };
                                                                        const logDetails = getLogDetails();

                                                                        const configToken = {
                                                                            headers: {
                                                                                'Authorization': `Bearer ${logDetails.token}`,
                                                                            },
                                                                        };
                                                                        axios.post(`${web_url}/api/auth/translator/${localStorage.getItem('t-userId')}/schools/${school.id}`, {}, configToken).then((response) => {
                                                                            setIsLoading(false);
                                                                        }).catch((err) => {
                                                                            console.error('Error:', err);
                                                                            if (err.response.data.message) {
                                                                                handleClickOpenError(err.response.data.message)
                                                                            } else {
                                                                                handleClickOpenError("error occured")
                                                                            }
                                                                            setIsLoading(false);
                                                                        });
                                                                    }
                                                                } else {
                                                                    setSchoolsSelected(schoolsSelected.filter(id => id !== school.id));
                                                                    if (localStorage.getItem('t-userId')) {
                                                                        setIsLoading(true);
                                                                        const getLogDetails = () => {
                                                                            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                                                                        };
                                                                        const logDetails = getLogDetails();

                                                                        const configToken = {
                                                                            headers: {
                                                                                'Authorization': `Bearer ${logDetails.token}`,
                                                                            },
                                                                        };
                                                                        axios.delete(`${web_url}/api/auth/translator/${localStorage.getItem('t-userId')}/schools/${school.id}`, configToken).then((response) => {
                                                                            setIsLoading(false);
                                                                        }).catch((err) => {
                                                                            console.error('Error:', err);
                                                                            if (err.response.data.message) {
                                                                                handleClickOpenError(err.response.data.message)
                                                                            } else {
                                                                                handleClickOpenError("error occured")
                                                                            }
                                                                            setIsLoading(false);
                                                                        });
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <div className="flex flex-col items-center">
                                                                <p className=" text-[17px] font-bold">{school.name}</p>
                                                                <p className=" text-[16px]">{school.district}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </>
                                    :
                                    <div className="flex justify-center pt-[40px]">
                                        <p className="text-[15px] md:text-[20px] xl:text-[17px] text-black font-bold">{t('t431')}</p>
                                    </div>

                            }
                        </div>

                    </div>
            }

            {/* <div className="xl:hidden grid grid-cols-3 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home-y.svg" alt="home" onClick={() => navigate('/mobile/researcher/dashboard')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" alt="person" onClick={() => navigate('/mobile/researcher/profile')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" alt="settings" onClick={() => navigate('/mobile/researcher/settings')} /></div>
            </div> */}

            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        The excel sheet uploaded successfully.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose1}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openAlert}
                onClose={handleCloseAlert}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    Incorrect format
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <p>Please make sure the document format is corresponding with the following and try again.</p>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className="pt-[20px]">
                        <li>First column should be student email</li>
                        <li>Second column should be penpal's email</li>
                        <li> Third column should be the group(either CONTROL or TREATMENT)</li>
                        <li> Sheet shouldn't have column names.</li>
                    </ul>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseAlert}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ResearcherTranslatorSchoolMatching;
